import { styled } from '@mui/material/styles'
import IconButton from '@mui/material/IconButton'
import List from '@mui/material/List'

const AGENT_ROWS = 8
const AGENT_ROW_HEIGHT = 48

export const CloseButton = styled(IconButton)({
  position: 'absolute',
  right: 0,
  top: 4,
  color: 'rgba(0, 0, 0, 0.54)',
})

export const ListContainer = styled('div')({
  paddingLeft: 15,
  paddingRight: 15,
  marginBottom: 5,
  flexGrow: 1,
  display: 'flex',
})

export const AgentList = styled(List)({
  overflow: 'auto',
  height: AGENT_ROW_HEIGHT * AGENT_ROWS,
})

export const EmptyAgentList = styled(AgentList)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  color: 'rgba(0, 0, 0, 0.54)',
})
